import * as api from '@/backend/api'
import { isErrorResponse } from '@/backend/error/types'
import { errorMessages } from '@/backend/error/errors'
import { parseError } from '@/backend/error'

import type { ApiResult } from './types'
import type { DatasetLabelPayload } from '@/store/types/DatasetLabelPayload'

type Params = {
  name: string
  color: string
  dataset_ids: number[]
}

export const updateDatasetLabel = async (
  teamSlug: string,
  labelId: string,
  params: Params,
): Promise<ApiResult<DatasetLabelPayload>> => {
  try {
    const path = `v2/teams/${teamSlug}/datasets/labels/${labelId}`
    const response = await api.put<DatasetLabelPayload>(path, {
      name: params.name,
      color: params.color,
      dataset_ids: params.dataset_ids,
    })

    return { ok: true, data: response.data }
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }
    return { ...parseError(error, errorMessages.DATASET_LABEL_UPDATE), ok: false }
  }
}
